"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _css = require("@emotion/css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _box = _interopRequireDefault(require("@amzn/meridian-tokens/component/box"));
var _card = _interopRequireDefault(require("@amzn/meridian-tokens/component/card"));
var _theme = require("../theme");
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
var _cxMemoized = _interopRequireDefault(require("./../_utils/cx-memoized"));
var _box2 = require("./../_styles/box");
var _propTypes2 = _interopRequireDefault(require("./../_prop-types"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var childContainerStyles = (0, _css.css)({
  overflowY: "hidden"
});

/**
 * This component renders a floating styled box.
 */
var FloatingBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    onClick = props.onClick,
    onKeyDown = props.onKeyDown,
    id = props.id,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    tabIndex = props.tabIndex,
    tag = props.tag;
  var t = (0, _theme.useTheme)(_box["default"], "box");
  var c = (0, _theme.useTheme)(_card["default"], "card");
  return /*#__PURE__*/_react["default"].createElement(tag, _objectSpread(_objectSpread({}, (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"])), {}, {
    className: "".concat((0, _cxMemoized["default"])((0, _box2.themedStyles)(t)(props), className), " ").concat((0, _box2.cardStyles)(c)),
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    id: id,
    role: "region",
    ref: ref,
    tabIndex: tabIndex
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: childContainerStyles
  }, children));
});
FloatingBox.displayName = "FloatingBox";
FloatingBox.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  id: _propTypes["default"].string,
  spacingInset: _propTypes2["default"].spacing(4),
  tabIndex: _propTypes["default"].string,
  tag: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onMouseEnter: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func
} : {};
FloatingBox.defaultProps = {
  tag: "div",
  spacingInset: "none"
};
var _default = FloatingBox;
exports["default"] = _default;